// src/components/common/SectionCard.js
import React from 'react';
import { ChevronRight } from 'lucide-react';

const SectionCard = ({ icon, title, description, color, onClick, disabled = false }) => {
  return (
    <div 
      className={`
        ${color} text-white p-6 rounded-2xl shadow-lg cursor-pointer 
        transform hover:scale-105 transition-all duration-200
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
      `}
      onClick={disabled ? undefined : onClick}
    >
      <div className="flex items-center justify-between">
        <div>
          {icon}
          <h3 className="text-xl font-bold mt-2">{title}</h3>
          <p className="text-white/80 mt-1">{description}</p>
        </div>
        <ChevronRight className="w-6 h-6" />
      </div>
    </div>
  );
};

export default SectionCard;